"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfTableRow = void 0;
var table_row_1 = require("../../../../core/model/tables/main-structures/table-row");
var list_1 = require("@devexpress/utils/lib/utils/list");
var table_row_properties_1 = require("./properties/table-row-properties");
var RtfTableRow = (function () {
    function RtfTableRow(table) {
        this.offset = 0;
        this.index = -1;
        this.properties = new table_row_properties_1.RtfTableRowProperties();
        this.table = table;
        this.cells = [];
    }
    Object.defineProperty(RtfTableRow.prototype, "right", {
        get: function () {
            var lastCell = list_1.ListUtils.last(this.cells);
            return lastCell ? lastCell.properties.right : 0;
        },
        enumerable: false,
        configurable: true
    });
    RtfTableRow.prototype.createTableRow = function (parentTable) {
        var row = new table_row_1.TableRow(parentTable, this.properties.coreProperties);
        this.properties.apply(row);
        return row;
    };
    return RtfTableRow;
}());
exports.RtfTableRow = RtfTableRow;
